export default __webpack_public_path__ + "static/equilibre_icon_hand-1ea7b357551a9cf47a38cbb9cb8076fc.png";